import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  ChangeDetectorRef,
  NgZone,
  Input,
  EventEmitter,
  Output,
  Optional,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '@app/core/services/common.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { ChatMessageType, ChatRoomType, eUserType } from '@app/shared/enum/user-type';
import { SocketService } from '@app/modules/carrier/services/socket.service';
import { SharedModalService } from '@app/shared/services/shared-modal.service';
import { PendingAttachment } from '@app/shared/models/chat-attachment.model';

@Component({
  selector: "app-chat-box",
  templateUrl: "./chat-box.component.html",
  styleUrls: ["./chat-box.component.scss"],
})
export class ChatBoxComponent implements OnInit {

  @ViewChild('scrollMe') myScrollContainer!: ElementRef;
  @ViewChild('inputFile') myInputVariable!: ElementRef;

  joinRoomId: string = null;
  sender: any;
   applyClass = false;
   @Input() showContractDetail = true;
  onlineUsers = new Set<number>();

  messages: any[] = [];
  groupedMessages: any[] = [];
  Members = 2
  limit = 20;
  openModel:boolean
  cursorId: number | null = null;
  hasMore = true;
  @Input() public data: any;
  isLoading = false;
  socketReady = false;
  autoScroll = true;
  chatMemberName:any
  private readMessageSet = new Set<number>();
  scrollLock: 'UP' | 'DOWN' | null = null;
  isSearchJump = false;
  hasSearched = false;
  hasMoreOlder = true;
  hasMoreNewer = true;
  newMessagesCount = 0;
  hasNewMessages:any
  chatMembers:any
  editingMessageId: number | null = null;
  editedText: string = '';
  _emptyMessageError = false;
  replyToMessage: {
  messageId: number;
  message: string;
  senderName: string;
} | null = null;


  private messageIdSet = new Set<number>();
  private attachmentPreviewCache = new Map<string, string>();
  private attachmentPreviewLoading = new Set<string>();
  /** Keys whose preview fetch failed, mapped to the timestamp of the failure. */
  private attachmentPreviewFailed = new Map<string, number>();
  private readonly attachmentPreviewRetryMs = 30000;

  pendingAttachments: PendingAttachment[] = [];
  isDraggingAttachment = false;
  private dragCounter = 0;
  LoadId = null
  searchKeyword: string = '';
  isSearching = false;
  searchResults: any[] = [];
  searchPage = 1;
  searchPageSize = 20;
  hasMoreSearch = false;
  openChatBox = true
  isStaff: boolean = false;
  isShipper: boolean = false;
  
   profileUrl = this._localStorageService.getValueByKey('profileUrl');
  companyName = this._localStorageService.getValueByKey('companyName');
  loggedInUsername = this._localStorageService.getValueByKey('loggedInUsername');
  userType:any = this._localStorageService.getValueByKey('userType');
  currectUserId:any = Number(this._localStorageService.getValueByKey('userId'));
  seenPopoverMessage: any = null;
   @Output() childToParent = new EventEmitter<boolean>();



constructor(
  private socketService: SocketService,
  private http: HttpClient,
  private commonService: CommonService,
  private _localStorageService: LocalStorageService,
  private cdr: ChangeDetectorRef,
   private _sharedModalService: SharedModalService,
  private ngZone: NgZone,
  @Optional() public dialogRef: MatDialogRef<ChatBoxComponent>,
  @Optional() @Inject(MAT_DIALOG_DATA) public chatData: any
) {
   
}


  // ================= INIT =================
  async ngOnInit(): Promise<void> {
     this.data = this.chatData || this.data;
    this.sender = this.data.senderInfo;
    await this.socketService.connect(this.currectUserId);
    this.socketReady = true;
    this.messages = [];
    this.groupedMessages = [];
    this.messageIdSet.clear();
    this.cursorId = null;
    this.hasMore = true;
    this.autoScroll = true;
    this.socketService.onUserOnline((data) => {
      this.loadOnlineUsers()
    });

    this.socketService.onUserOffline((data) => {
      this.loadOnlineUsers()
    });
    this.socketService.onNewMessage(async (msg: any) => {
    const normalized = this.normalizeMessage(msg);
     if (localStorage.getItem('loggedInUsername').toLowerCase() != normalized.userName?.toLowerCase()) {
          if(Notification.permission == 'granted') {
              const payload = {
                  body: normalized?.message,
                };
            navigator.serviceWorker.getRegistration().then((registration) => {
              registration.showNotification(normalized.userName, payload);
            })
          }
        }
        this.socketService.onMessageSeen((payload) => {
          const seenUsers = payload.data;
          if (!Array.isArray(seenUsers) || !seenUsers.length) return;
          const lastMessage = this.messages[this.messages.length - 1];
          if (!lastMessage) return;
          lastMessage.seenBy = lastMessage.seenBy || [];
          seenUsers.forEach((user) => {
            const exists = lastMessage.seenBy.some((u) => u.id === user.id);
            if (!exists) {
              lastMessage.seenBy.push(user);
            }
          });
        });
        if(this.openChatBox && normalized.userName != this.loggedInUsername){
          this.markMessageAsRead(normalized);
        }
       this.ngZone.run(() => {
        if (this.messageIdSet.has(normalized.id)) return;
        const wasAtBottom = this.isUserAtBottom();
        this.messageIdSet.add(normalized.id);
        this.messages.push(normalized);
        this.groupByDate();
 
        if (wasAtBottom) {
          this.newMessagesCount = 0;
          this.hasNewMessages = false;
          setTimeout(() => this.scrollToBottom());
        } else {
          this.newMessagesCount++;
          this.hasNewMessages = true;
          this.cdr.detectChanges();
        }
      });
    });
     this.socketService.onMessageDeleted(({ messageId }) => {
    this.messages = this.messages.map(msg =>
      msg.id === messageId
        ? {
            ...msg,
            message: 'This message was deleted',
            metadata: { ...(msg.metadata || {}), isDeleted: true },
          }
        : msg
    );
    this.groupByDate();
  });

  this.socketService.onMessageEdited(updatedMsg => {
    const index = this.messages.findIndex(m => m.id === updatedMsg.id);
    if (index === -1) return;

    this.messages[index] = {
      ...this.messages[index],
      message: updatedMsg.message,
      metadata: {
        ...(this.messages[index].metadata || {}),
        ...(updatedMsg.metadata || {}),
        edited: true,
      },
    };

    this.groupByDate();
  });
    this.socketService.onReadReceipt((data) => {
      const msg = this.messages.find((m) => m.id === data.messageId);
      if (!msg) return;
      msg.readAt = data.readAt;
      msg.readBy = msg.readBy || [];
      if (!msg.readBy.includes(data.userId)) {
        msg.readBy.push(data.userId);
      }
    });
  
    this.loadOnlineUsers()
    this.loadMessages();
  }

    checkSaffType(){
    const userType = parseInt(localStorage.getItem('userType'));
    if (userType === this.eUserType.SHIPPER) {
      this.isStaff = true;
    } else {
      this.isStaff = false;
    }
    this.isShipper = userType === eUserType.SHIPPER;
  }
   get eUserType(){
    return eUserType;
  }

   get eChatMessageType(){
    return ChatMessageType;
  }

  loadOnlineUsers() {
  this.socketService.getOnlineUsers().subscribe({
    next: (res) => {
      const onlineUsers = res?.data?.onlineUsers || [];
      this.createPrivateRoom(onlineUsers)
    },
    error: (err) => {
      this.commonService.showSnakeBar('SHOULD NOT HAPPEN NOW');
    },
  });

  }
  markMessageAsRead(message: any): void {
    // if (this.isOwnMessage(message)) return;
    if (!message.chatRoomId) {
      return;
    }
    
  this.socketService
    .chatMessageMarkAsRead(message.chatRoomId, message.id)
    .subscribe({
      next: () => {},
      error: err => {},
    });
}

 showGroupInfo = false;
  showSearchPanel = false;
  showContractPanel = false;

  toggleGroupInfo() {
    if (this.showSearchPanel) {
      this.showSearchPanel = false;
    }
    if (this.showContractPanel) {
      this.showContractPanel = false;
    }
    this.showGroupInfo = !this.showGroupInfo;
  }

  toggleSearchPanel() {
    if (this.showGroupInfo) {
      this.showGroupInfo = false;
    }
    if (this.showContractPanel) {
      this.showContractPanel = false;
    }
    this.showSearchPanel = !this.showSearchPanel;
  }

  toggleContractPanel() {
    if (this.showGroupInfo) {
      this.showGroupInfo = false;
    }
    if (this.showSearchPanel) {
      this.showSearchPanel = false;
    }
    this.showContractPanel = !this.showContractPanel;
  }
    onSendOrEdit(input: HTMLInputElement) {
      const text = input.value.trim();
      if (!text && !this.pendingAttachments.length) { this._emptyMessageError = true; return; }
      this._emptyMessageError = false;
      if (this.editingMessageId) {
        const message = this.messages.find(
          m => m.id === this.editingMessageId
        );
        if (!message) return;

        this.saveEdit(message);
        input.value = '';
      } 
      else {
        this.sendMessage(text);
        input.value = '';
      }
    }

  isUserAtBottom(): boolean {
    const el = this.myScrollContainer?.nativeElement;
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 30;
  }

  onUserScroll(): void {
    if (!this.isUserAtBottom()) {
      this.autoScroll = false;
    }
  }

  scrollToBottom(): void {
    try {
      const el = this.myScrollContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    } catch {}
  }

createPrivateRoom(checkOnlineUsers) {
  const memberOneId = Number(this.data.shipperId) || Number(this.data.carrierId);
  const memberTwoId =  this.data.staffId ? Number(this.data.staffId) : Number(this.data.carrierId);
  const members = {
    memberOneId,
    memberTwoId,
  };

 this.socketService.createPrivateRoom(members).subscribe({
  next: (res) => {
    if (res.statusCode === 200) {
      const onlineUsers: number[] = checkOnlineUsers || [];
      this.chatMemberName = res.data.members.map((member: any) => ({
        ...member,
        isOnline: onlineUsers.includes(member.id),
        role: member.id === this.currectUserId ? "You" : member.role,
      }));
    }
  },
  error: (err) => {
    this.commonService.showSnakeBar('create private room error');
  },
});

}



  loadMessages(): void {
    if (this.isLoading || !this.hasMore) return;
    this.isLoading = true;
    const container = this.myScrollContainer?.nativeElement;
    const prevScrollHeight = container?.scrollHeight || 0;
    const isFirstLoad = this.cursorId === null;

   const cursorId =
    this.messages.length > 0
      ? String(this.messages[0].id)
      : "";

  const payload = {
    type: ChatRoomType.PRIVATE,
    loadId: this.LoadId,
    pageSize: this.limit,
    memberOneId: Number(this.data.shipperId) || Number(this.data.carrierId),
    memberTwoId: this.data.staffId ? Number(this.data.staffId) : Number(this.data.carrierId),
    cursorId,
  };

    this.socketService.getmessages(payload).subscribe(async (res) => {
      const messages = res?.messages || res?.data?.messages || [];
      const pagination = res?.pagination || res?.data?.pagination;
      this.hasMore = pagination?.hasMore ?? false;
      this.cursorId = pagination?.nextCursorId ?? null;

    const roomId = res?.room?.id || res?.data?.room?.id;

      if (!this.joinRoomId && roomId) {
        this.joinRoomId = String(roomId);
        await this.socketService.joinRoom(this.joinRoomId);
      }
      const uniqueMessages = messages.filter((msg: any) => {
        if (this.messageIdSet.has(msg.id)) return false;
        this.messageIdSet.add(msg.id);
        return true;
      });
      if (uniqueMessages.length) {
        const normalized = uniqueMessages
          .map(m => this.normalizeMessage(m))
          .reverse();
        this.messages = [...normalized, ...this.messages];
        const lastMessage = this.messages[this.messages.length - 1];
        this.markMessageAsRead(lastMessage);
        this.groupByDate();
      }

      this.isLoading = false;
      this.cdr.detectChanges();
      if (!isFirstLoad && container && uniqueMessages.length) {
        const newHeight = container.scrollHeight;
        container.scrollTop = newHeight - prevScrollHeight;
      }
      if (isFirstLoad) {
        setTimeout(() => this.scrollToBottom());
      }
    });
  }
  onScrollUp(): void {
    if (this.isLoading || !this.hasMore) return;
    this.autoScroll = false;
    this.loadMessages();
  }

normalizeMessage(msg: any) {
  let dateObj: Date;

  if (msg.messageDate instanceof Date) {
    dateObj = msg.messageDate;
  } else if (msg.messageDate) {
    dateObj = new Date(msg.messageDate);
  } else {
    dateObj = new Date();
  }

  let parsedMetadata: any = null;

  if (msg.metadata) {
    if (typeof msg.metadata === 'string') {
      try {
        parsedMetadata = JSON.parse(msg.metadata);
      } catch {
        parsedMetadata = null;
      }
    } else {
      parsedMetadata = msg.metadata;
    }
  }

  return {
    id: msg.id,
    chatRoomId: msg.chatRoomId,
    senderId: msg.senderId,
    message: msg.message,
    metadata: parsedMetadata,
    userName: msg?.sender?.name,
    messageType: msg.messageType,
    messageDate: dateObj,
    senderProfileImage: msg.senderProfileImage,
    seenBy: msg.seenBy || [],
  };
}
  isImageMessage(chat: any): boolean {
    return !chat?.metadata?.isDeleted
      && chat?.messageType === ChatMessageType.IMAGE
      && !!chat?.metadata?.attachment;
  }

  isFileMessage(chat: any): boolean {
    return !chat?.metadata?.isDeleted
      && chat?.messageType === ChatMessageType.FILE
      && !!chat?.metadata?.attachment;
  }

  isTextMessage(chat: any): boolean {
    return !this.isImageMessage(chat) && !this.isFileMessage(chat);
  }

  copyMessage(chat: any): void {
  if (!chat?.message || chat.metadata?.isDeleted) return;
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(chat.message).then(
      () => {
        this.commonService.showSnakeBar('Message copied');
      },
      () => {
        this.fallbackCopy(chat.message);
      }
    );
  } else {
    this.fallbackCopy(chat.message);
  }
}
private fallbackCopy(text: string): void {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    document.execCommand('copy');
    this.commonService.showSnakeBar('Message copied');
  } catch {
    this.commonService.showSnakeBar('Failed to copy message');
  }

  document.body.removeChild(textarea);
}

  isMessageSeen(chat: any): boolean {
    const totalMembers = 2;

    if (!chat?.seenBy) return false;

    return chat.seenBy.length === totalMembers;
  }

isLastMessageOverall(chat: any): boolean {
  if (!this.messages.length) return false;

  const lastMessage = this.messages[this.messages.length - 1];
  return lastMessage.id === chat.id;
}


  groupByDate(): void {
    const grouped: any = {};
    this.messages.forEach(msg => {
      const dateKey = msg.messageDate.toDateString();
      grouped[dateKey] = grouped[dateKey] || [];
      grouped[dateKey].push(msg);
    });

    this.groupedMessages = Object.keys(grouped).map(date => ({
      date,
      messages: grouped[date],
    }));
  }

  trackByDate(index: number, item: any) {
    return item.date;
  }

 sendMessage(text: string): void {
  if (!this.socketReady) return;
  if (this.hasAnyPendingUpload) return;
  if (this.editingMessageId) {
    const message = this.messages.find(
      m => m.id === this.editingMessageId
    );
    if (message) {
      this.saveEdit(message);
    }
    return;
  }
  const attachments = this.pendingAttachments.filter(a => a.status === 'done');
  const hasText = text && text.trim().length > 0;
  if (!hasText && !attachments.length) {
    this._emptyMessageError = true;
    return;
  }
  this._emptyMessageError = false;
  const senderId = this.currectUserId;

  const replyMetadata: any = {};
  if (this.replyToMessage) {
    replyMetadata.replyTo = this.replyToMessage;
  }

  const basePayload = {
    type: ChatRoomType.PRIVATE,
    senderId,
    loadId: null,
    memberOneId: Number(this.data.shipperId) || Number(this.data.carrierId),
    memberTwoId: this.data.staffId ? Number(this.data.staffId) : Number(this.data.carrierId),
  };

  if (hasText) {
    this.sendChatPayload({
      ...basePayload,
      message: text.trim(),
      metadata: Object.keys(replyMetadata).length ? replyMetadata : null,
      messageType: ChatMessageType.TEXT,
    });
  }

  attachments.forEach(att => {
    this.sendChatPayload({
      ...basePayload,
      message: att.name,
      metadata: {
        ...(replyMetadata.replyTo ? { replyTo: replyMetadata.replyTo } : {}),
        attachment: {
          name: att.name,
          key: att.key,
          url: att.url,
          type: att.type,
          size: att.size,
          isImage: att.isImage,
        },
      },
      messageType: att.isImage ? ChatMessageType.IMAGE : ChatMessageType.FILE,
    });
  });

  this.pendingAttachments = [];
  this.replyToMessage = null;
  this.resetFile();
}

private sendChatPayload(payload: any): void {
  this.socketService.sendMessage(payload, async (ack) => {
    const msg = ack?.data;
    if (!msg) return;
    const normalized = this.normalizeMessage(msg);
    if (!this.messageIdSet.has(normalized.id)) {
      this.messageIdSet.add(normalized.id);
      this.messages.push(normalized);
      this.groupByDate();
      this.scrollToBottom();
      this.newMessagesCount = 0;
      this.hasNewMessages = false;
    }
    if (!this.joinRoomId) {
      this.joinRoomId = String(msg.chatRoomId);
      await this.socketService.joinRoom(this.joinRoomId);
    }
  });
}
startReplyMessage(chat: any): void {
  this.replyToMessage = {
    messageId: chat.id,
    message: chat.message,
    senderName: chat.userName,
  };
  // this.editedText = chat.message;
  this.editingMessageId = null;
}


      cancelReplyMessage(): void {
        this.replyToMessage = null;
        this.editedText = '';
      }

    startEditMessage(message: any): void {
      if (message.senderId !== this.currectUserId) return;
      // Images and documents are not editable.
      if (!this.canEditMessage(message)) return;
      this.editingMessageId = message.id;
      this.editedText = message.message;
    }

    cancelEdit(): void {
      this.editingMessageId = null;
      this.editedText = '';
    }

    saveEdit(message: any): void {
      if (!this.editedText.trim()) return;
      const payload = {
        messageId: message.id,
        userId: this.currectUserId,
        newMessage: this.editedText.trim(),
      };

      this.socketService.editMessage(payload, (ack) => {
        if (!ack?.data) return;
        const updated = this.normalizeMessage(ack.data);
        const index = this.messages.findIndex(m => m.id === updated.id);
        if (index !== -1) {
          this.messages[index] = {
          ...this.messages[index],
          message: updated.message,
          metadata: {
            ...(this.messages[index].metadata || {}),
            ...(updated.metadata || {}),
            edited: true
          }
        };
          this.groupByDate();
        }
        this.cancelEdit();
      });
    }
shouldShowAvatar(messages: any[], index: number): boolean {
  if (index === 0) return true;
  const current = messages[index];
  const previous = messages[index - 1];
  if (current.senderId !== previous.senderId) return true;
  const diffMs =
    current.messageDate.getTime() - previous.messageDate.getTime();
  const diffMinutes = diffMs / (1000 * 60);
  return diffMinutes > 1;
}
shouldShowTime(messages: any[], index: number): boolean {
  const current = messages[index];
  const next = messages[index + 1];

  // last message in date group
  if (!next) return true;

  // different sender → end of group
  if (current.senderId !== next.senderId) return true;

  // time difference
  const diffMs =
    next.messageDate.getTime() - current.messageDate.getTime();
  const diffMinutes = diffMs / (1000 * 60);

  // next message after 1 minute → end of group
  return diffMinutes > 1;
}


shouldShowUserName(messages: any[], index: number): boolean {
  return this.shouldShowAvatar(messages, index);
}


  onFileSelected(event: any): void {
    const files: File[] = Array.from((event?.target?.files || []) as FileList);
    this.handleSelectedFiles(files);
    if (event?.target) {
      event.target.value = '';
    }
  }

  onAttachmentDragEnter(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter++;
    this.isDraggingAttachment = true;
  }

  onAttachmentDragOver(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.isDraggingAttachment = true;
  }

  onAttachmentDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter--;
    if (this.dragCounter <= 0) {
      this.dragCounter = 0;
      this.isDraggingAttachment = false;
    }
  }

  onAttachmentDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter = 0;
    this.isDraggingAttachment = false;
    const files: File[] = Array.from((event?.dataTransfer?.files || []) as FileList);
    this.handleSelectedFiles(files);
  }

  private handleSelectedFiles(files: File[]): void {
    if (!files.length) {
      return;
    }
    files.forEach((file) => this.addPendingAttachment(file));
  }

  private getAttachmentIdentity(file: File): string {
    return `${(file?.name || '').trim().toLowerCase()}::${Number(file?.size || 0)}`;
  }

  private isVideoFile(file: File): boolean {
    if (!!file?.type && file.type.startsWith('video/')) {
      return true;
    }
    const fileName = (file?.name || '').toLowerCase();
    const extension = fileName.split('.').pop() || '';
    const knownVideoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'wmv', 'webm', 'flv', 'm4v', '3gp', 'mpeg', 'mpg'];
    return knownVideoExtensions.includes(extension);
  }

  private isDuplicateAttachment(file: File): boolean {
    const identity = this.getAttachmentIdentity(file);
    return this.pendingAttachments.some((attachment) => {
      if (!attachment?.name || !attachment?.size) {
        return false;
      }
      return `${attachment.name.trim().toLowerCase()}::${Number(attachment.size || 0)}` === identity;
    });
  }

  private addPendingAttachment(file: File): void {
    if (this.isDuplicateAttachment(file)) {
      this.commonService.showSnakeBar('This file has already been added.');
      return;
    }

    if (this.isVideoFile(file)) {
      this.commonService.showSnakeBar('This video format is not supported.');
      return;
    }

    const pending: PendingAttachment = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      isImage: !!file.type && file.type.startsWith('image/'),
      previewUrl: !!file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : '',
      key: '',
      url: '',
      status: 'uploading',
    };
    if (!this.isAllowedFileType(file)) {
      this.commonService.showSnakeBar('Unsupported file type. Allowed: images, PDF, DOC/DOCX, XLS/XLSX, PPT/PPTX, TXT, CSV.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.commonService.showSnakeBar('Max Size of Document should be 5MB.');
      return;
    }
    this.pendingAttachments.push(pending);
    this.uploadPendingAttachment(pending);
  }

  private isAllowedFileType(file: File): boolean {
    const allowedTypes = [
      'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml',
      'application/pdf', 'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain', 'text/csv', 'application/zip', 'application/x-zip-compressed',
    ];
    if (allowedTypes.includes(file.type)) return true;
    const name = (file.name || '').toLowerCase();
    const ext = name.split('.').pop() || '';
    const allowedExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'zip'];
    return allowedExts.includes(ext);
  }

  uploadPendingAttachment(pending: PendingAttachment): void {
    pending.status = 'uploading';
    const fd = new FormData();
    fd.append('file', pending.file);
    this.http.post('master/upload-file', fd).subscribe(
      (res: any) => {
        pending.status = 'done';
        pending.key = res?.data?.key || '';
        pending.url = res?.data?.signedUrl || res?.data?.blobUrl || '';
      },
      () => {
        pending.status = 'error';
        pending.error = 'Upload failed. Please try again.';
      }
    );
  }

  removePendingAttachment(id: string): void {
    const idx = this.pendingAttachments.findIndex(a => a.id === id);
    if (idx === -1) return;
    const removed = this.pendingAttachments[idx];
    if (removed.previewUrl) URL.revokeObjectURL(removed.previewUrl);
    this.pendingAttachments.splice(idx, 1);
  }

    getLength(message: string) {
    this.applyClass = message.length > 0;
  }

  get hasAnyPendingUpload(): boolean {
    return this.pendingAttachments.some(a => a.status === 'uploading');
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
  }

  downloadAttachment(chat: any): void {
    const att = chat?.metadata?.attachment;
    if (!att?.key) {
      this.commonService.showSnakeBar('Attachment not available');
      return;
    }
    this.http.get(
      this.getProxyAttachmentUrl(att.key, 'attachment'),
      this.getBlobRequestOptions()
    ).subscribe({
      next: (blob: Blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        this.triggerDownload(objectUrl, att.name || 'download');
        setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
      },
      error: () => {
        this.commonService.showSnakeBar('Unable to download file');
      },
    });
  }

  private triggerDownload(url: string, fileName: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  onImageError(event: any, chat: any): void {
    const img = event.target as HTMLImageElement;
    if (!img) return;
    const att = chat?.metadata?.attachment;
    if (!att?.key) {
      img.style.display = 'none';
      return;
    }
    const cached = this.attachmentPreviewCache.get(att.key);
    if (cached) {
      img.src = cached;
      return;
    }
    this.ensureAttachmentPreview(att.key);
    if (img.dataset?.retried) {
      img.style.display = 'none';
      return;
    }
    img.dataset.retried = 'true';
    img.style.display = '';
  }

  getAttachmentImageSrc(chat: any): string {
    const att = chat?.metadata?.attachment;
    if (!att) {
      return '';
    }
    if (att?.key) {
      const cached = this.attachmentPreviewCache.get(att.key);
      if (cached) {
        return cached;
      }
      this.ensureAttachmentPreview(att.key);
    }
    return att?.url || '';
  }

  private ensureAttachmentPreview(key: string): void {
    if (!key || this.attachmentPreviewCache.has(key) || this.attachmentPreviewLoading.has(key)) {
      return;
    }
    // getAttachmentImageSrc() is bound in the template and runs on every change
    // detection pass. Without a negative cache, a single storage outage (e.g. a
    // transient DNS failure) re-issues the request on every cycle, producing a
    // storm of 500s. Back off instead.
    const failedAt = this.attachmentPreviewFailed.get(key);
    if (failedAt !== undefined) {
      if (Date.now() - failedAt < this.attachmentPreviewRetryMs) {
        return;
      }
      this.attachmentPreviewFailed.delete(key);
    }
    this.attachmentPreviewLoading.add(key);
    this.http.get(
      this.getProxyAttachmentUrl(key, 'inline'),
      this.getBlobRequestOptions()
    ).subscribe({
      next: (blob: Blob) => {
        this.attachmentPreviewLoading.delete(key);
        if (!blob || !blob.size) {
          this.attachmentPreviewFailed.set(key, Date.now());
          this.cdr.detectChanges();
          return;
        }
        const objectUrl = URL.createObjectURL(blob);
        this.attachmentPreviewCache.set(key, objectUrl);
        this.attachmentPreviewFailed.delete(key);
        this.cdr.detectChanges();
      },
      error: () => {
        this.attachmentPreviewLoading.delete(key);
        this.attachmentPreviewFailed.set(key, Date.now());
      }
    });
  }

  private getProxyAttachmentUrl(key: string, disposition: 'inline' | 'attachment'): string {
    return `master/document?key=${encodeURIComponent(key)}&disposition=${disposition}`;
  }

  private getBlobRequestOptions() {
    const token = localStorage.getItem('userToken');
    const headersConfig: any = {};
    if (token) {
      headersConfig.Authorization = 'Bearer ' + token;
      headersConfig.Device = 'Desktop';
    }
    return {
      headers: new HttpHeaders(headersConfig),
      responseType: 'blob' as const
    };
  }


  resetFile(): void {
    this.isDraggingAttachment = false;
    this.pendingAttachments.forEach(a => {
      if (a.previewUrl) URL.revokeObjectURL(a.previewUrl);
    });
    this.pendingAttachments = [];
    if (this.myInputVariable?.nativeElement) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

closeChatDialog(): void {
  this.openChatBox = false
  this.childToParent.emit(false);
  this.attachmentPreviewCache.forEach((url) => {
    try { URL.revokeObjectURL(url); } catch {}
  });
  this.attachmentPreviewCache.clear();
  this.attachmentPreviewLoading.clear();
  this.attachmentPreviewFailed.clear();
    this.dialogRef.close('save');
  }

  toggleSeenPopover(chat: any, event: MouseEvent) {
  event.stopPropagation();

  if (this.seenPopoverMessage === chat) {
    this.seenPopoverMessage = null;
  } else {
    this.seenPopoverMessage = chat;
  }
   }
     deleteMessage(chat: any): void {
    if (!chat?.id) {
      this.commonService.showSnakeBar('Some error occurred');
      return;
    }

    this._sharedModalService
      .delete('Do you really want to delete this message?')
      .subscribe((res: boolean) => {
        if (!res) return;
        this.socketService.deleteMessage(chat.id, this.currectUserId);
        this.commonService.showSnakeBar('Message deleted');
      });
  }
onSearchMessages(): void {
  if (!this.searchKeyword.trim() || !this.joinRoomId || this.isSearching) return;

  this.hasSearched = true;
  this.isSearching = true;
  this.isSearchJump = false;

  this.searchResults = [];
  this.searchPage = 1;
  this.hasMoreSearch = true;

  this.socketService.searchMessages({
    roomId: Number(this.joinRoomId),
    keyword: this.searchKeyword.trim(),
    pageNumber: this.searchPage,
    pageSize: this.searchPageSize,
  }).subscribe({
    next: res => {
      this.searchResults = res?.data?.messages || [];
    },
    error: () => {
      this.commonService.showSnakeBar('Search failed');
      this.isSearching = false;
    },
    complete: () => {
      this.isSearching = false;
    }
  });
}
 scrollToNewMessages(): void {
    this.scrollToBottom();
    this.newMessagesCount = 0;
    this.hasNewMessages = false;
    this.autoScroll = true;
  }
canEditDeleteMessage(chat: any): boolean {
  if (!chat?.messageDate) return false;
  const messageTime = new Date(chat?.messageDate).getTime();
  const currentTime = Date.now();
  const diffInMinutes = (currentTime - messageTime) / (1000 * 60);
  return diffInMinutes <= 20;
}
canEditMessage(chat: any): boolean {
  if (this.isImageMessage(chat) || this.isFileMessage(chat)) return false;
  if (chat?.metadata?.attachment) return false;
  return this.canEditDeleteMessage(chat);
}

jumpToSearchMessage(chat: any): void {
  if (!chat?.id || !this.joinRoomId) return;

  this.isSearchJump = true;
  this.isLoading = true;
  this.hasMoreOlder = true;
  this.hasMoreNewer = true;

  this.socketService.getMessagesAround({
    roomId: Number(this.joinRoomId),
    messageId: chat.id,
    pageSize: 20,
  }).subscribe(res => {
    const msgs = res?.data?.messages || [];

    this.messages = [];
    this.groupedMessages = [];
    this.messageIdSet.clear();

    const normalized = msgs.map(m => this.normalizeMessage(m));
    normalized.forEach(m => this.messageIdSet.add(m.id));

    this.messages = normalized;
    this.groupByDate();
    this.cdr.detectChanges();

    setTimeout(() => {
      const el = document.getElementById(`message-${chat.id}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.classList.add('highlight-message');

        setTimeout(() => {
          el.classList.remove('highlight-message');
        }, 2000);
      }
      this.isLoading = false;
    }, 0);
  });
}

loadOlderFromSearch(): void {
  if (this.isLoading || !this.hasMoreOlder || !this.messages.length) return;

  this.isLoading = true;

  const el = this.myScrollContainer.nativeElement;
  const prevHeight = el.scrollHeight;
  const cursorId = String(this.messages[0].id);

  this.socketService.getmessages({
    type: ChatRoomType.PRIVATE,
    loadId: this.LoadId,
    pageSize: this.limit,
    memberOneId: Number(this.data.shipperId) || Number(this.data.carrierId),
    memberTwoId: this.data.staffId
      ? Number(this.data.staffId)
      : Number(this.data.carrierId),
    cursorId,
  }).subscribe(res => {
    const msgs = res?.data?.messages || [];

    if (!msgs.length) {
      this.hasMoreOlder = false;
      this.isLoading = false;
      return;
    }

    const normalized = msgs
      .map(m => this.normalizeMessage(m))
      .filter(m => !this.messageIdSet.has(m.id))
      .reverse();

    normalized.forEach(m => this.messageIdSet.add(m.id));

    this.messages = [...normalized, ...this.messages];
    this.groupByDate();
    this.cdr.detectChanges();

    el.scrollTop = el.scrollHeight - prevHeight;
    this.isLoading = false;
  });
}


loadNewerFromSearch(): void {
  if (this.isLoading || !this.hasMoreNewer || !this.messages.length) return;

  this.isLoading = true;

  const cursorId = String(this.messages[this.messages.length - 1].id);

  this.socketService.getmessages({
    type: ChatRoomType.PRIVATE,
    loadId: this.LoadId,
    pageSize: this.limit,
    memberOneId: Number(this.data.shipperId) || Number(this.data.carrierId),
    memberTwoId: this.data.staffId
      ? Number(this.data.staffId)
      : Number(this.data.carrierId),
    cursorId,
    direction: 'NEWER',
  }).subscribe(res => {
    const msgs = res?.data?.messages || [];

    if (!msgs.length) {
      this.hasMoreNewer = false;
      this.isLoading = false;
      return;
    }

    const normalized = msgs
      .map(m => this.normalizeMessage(m))
      .filter(m => !this.messageIdSet.has(m.id));

    normalized.forEach(m => this.messageIdSet.add(m.id));

    this.messages = [...this.messages, ...normalized];
    this.groupByDate();
    this.cdr.detectChanges();

    this.isLoading = false;
  });
}

  onContainerScroll(): void {
  const el = this.myScrollContainer?.nativeElement;
  if (!el || this.isLoading) return;

  const atTop = el.scrollTop < 50;
  const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50;
     if (atBottom) {
        this.autoScroll = true;
        if (this.hasNewMessages) {
          this.newMessagesCount = 0;
          this.hasNewMessages = false;
        }
      } else {
        this.autoScroll = false;
      }

  if (!this.isSearchJump) {
    if (atTop && this.hasMore) {
      this.loadMessages();
    }
    return;
  }

  if (atTop) {
    this.loadOlderFromSearch();
  }

  if (atBottom) {
    this.loadNewerFromSearch();
  }
}

clearSearch(): void {
  this.searchKeyword = '';
  this.searchResults = [];
  this.isSearching = false;
  this.hasSearched = false;
  this.isSearchJump = false;
  this.hasMoreOlder = true;
  this.hasMoreNewer = true;
}


}
